import React, { useContext, useState } from 'react';
import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Modal, Space, Tooltip, message } from 'antd';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { TourStoryType } from '../../../../types/tourStory';
import { TOUR_STORIES } from '../../../../constants/define/translation';
import { deleteTourStoryRepository } from '../../../../repository/mytm/tourStory/tourStoryRepository';
import { btnActive } from '../../../../styles';
import { MESSAGE_ERROR } from '../../../../constants/message';
import { ConfirmAction } from '../../../molecules/confirm/ConfirmAction';
import { postLoginRepository } from '../../../../repository/mytm/auth/loginRepository';
import { UserContext } from '../../../../repository/context/userContext';
import { CONFIG_CONTAINER_NAME, deleteBlob } from '../../../../utils/azure';

interface ActionsColumnProps {
  record: TourStoryType;
  onRefresh: () => void;
  total: number;
  handleChangePageActive: Function;
  removeItemByIndex: Function;
  setLoading: (value: boolean) => void;
}

export default React.memo((props: ActionsColumnProps) => {
  const { t } = useTranslation(TOUR_STORIES);
  const userContext = useContext(UserContext);
  const [deleting, setDeleting] = useState(false);
  const { record, onRefresh, handleChangePageActive, total, setLoading, removeItemByIndex } = props;
  const handleDelete = async () => {
    if (!record.id && record.isSwitchVideo) {
      removeItemByIndex(record.index);
      return;
    }
    Modal.confirm({
      title: t('table.popup.title'),
      okText: t('table.popup.okBtn'),
      cancelText: t('table.popup.cancelBtn'),
      icon: <ExclamationCircleOutlined />,
      content: (
        <ConfirmAction
          textConfirmAction={t('table.popup.delete')}
          isConfirmPassword
          textConfirmPassword={t('table.popup.confirmPassword')}
        />
      ),
      onOk() {
        setDeleting(true);
        const updateFunc = () => {
          deleteTourStoryRepository(record?.id)
            .then(res => {
              deleteBlob(record?.url, CONFIG_CONTAINER_NAME.UPLOADS).then().catch();
              message.success(t('message.success.deleteTourStory'));
            })
            .catch(() => message.error(MESSAGE_ERROR.M02))
            .finally(() => {
              const numRecord = total - 1;
              if (numRecord && numRecord > 0) {
                onRefresh();
              } else {
                handleChangePageActive(1);
              }
              setDeleting(false);
            });
        };
        const inputPasswordNode = document.getElementById('inputPasswordForConfirm');
        const password = (inputPasswordNode as any).value;
        if (!userContext.user?.email || userContext.user?.email === '') {
          setLoading && setLoading(false);
          message.error(MESSAGE_ERROR.M02);
        } else {
          postLoginRepository({
            email: userContext.user?.email,
            password,
          })
            .then(() => {
              updateFunc();
            })
            .catch((e: any) => {
              setDeleting(false);
              message.error(e?.errorMessage);
            });
        }
      },
    });
  };

  return (
    <StyledContainer>
      <Space size="small">
        <Tooltip title={t('table.tooltip.delete')}>
          <Button icon={<DeleteOutlined />} onClick={handleDelete} disabled={deleting} loading={deleting} />
        </Tooltip>
      </Space>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0.5rem;
  ${btnActive}
`;
